import StakeholderEditItem from "./StakeholderEditItem"
import stakeholderItemConnector from "../stakeholder-item-connector"

export default stakeholderItemConnector(StakeholderEditItem)
